exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#fullScreen {\n  margin-top: 10%;\n}\n#fullScreen .ant-result {\n  padding: 15px 32px;\n}\n#fullScreen .ant-result-title {\n  margin-bottom: 20px;\n}\n#fullScreen .ant-btn-danger {\n  margin-top: 30px;\n}\n#fullScreen div {\n  text-align: center;\n}", ""]);

// exports
